import React, { useState,useRef, useEffect } from 'react';
import {Link} from 'react-router-dom' 
import N3rveLogo from './../../../images/N3rveLogo.png'
import './VerifyEmail.css'
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { setAppElement } from 'react-modal';
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import validator from 'validator'

function VerifyEmail() {
  const [email, setEmail] = useState('')
  const [password,setPassword] = useState('')
  const [password2,setPassword2] = useState('')
  const [code,setCode] = useState('')
  const [buttonClick,setButtonClick] = useState(0)
  const navigate = useNavigate()
  const location = useLocation();
  const [timeLeft, setTimeLeft] = useState(null);
  const params = new URLSearchParams(document.location.search);
  const cookies = new Cookies(null ,{ path: '/' });
  const [passwordSyntaxError , setPasswordSyntaxError ] = useState(false)
  const [passwordEmptyError , setPasswordEmptyError ] = useState(false)
  const [confirmError , setConfirmPasswordError ] = useState(false)
  const [passwordMismatchError , setPasswordMismatchError ] = useState(false)
  const {t, i18n } = useTranslation();

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })
  
  useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })  
}
    window.addEventListener('resize', handleResize)
    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  })

  const validate = (value)=> { 
    if (validator.isStrongPassword(value, { 
        minLength: 8, minLowercase: 1, 
        minUppercase: 1, minNumbers: 1, minSymbols: 1 
    })) { 
        setPasswordSyntaxError(false) 
    } else { 
        setPasswordSyntaxError(true) 
    } 
} 

const handleSubmit = () =>{
  
  if(password.length===0){
    setPasswordEmptyError(true)
  }else{
    setPasswordEmptyError(false)
  }
  if(password2.length===0){
    setConfirmPasswordError(true)
  }else{
    setConfirmPasswordError(false)
  }

  if(password!==password2 && password2.length!==0){
    setPasswordMismatchError(true)
  }else{
    setPasswordMismatchError(false)
  }

  if(!passwordEmptyError && !confirmError && !passwordMismatchError){
    changePassword()
  }

}


  useEffect(()=>{
    console.log(params.get("password"))
    console.log(params.get("email"))
    if(params.get("password")===null){
      if(location.state!==null){
        setEmail(location.state.email)
        setPassword(location.state.password)
        setPassword2(location.state.password2)
      }else{
         setEmail(params.get("email"))
         setCode(params.get("code"))
         console.log("email")
         console.log(params.get("email"))
         console.log()
         if(params.get("email").split(' ').length===1){
           VerifyProfile(params.get("email"),params.get("code"))
         }else{
           var emailarr= params.get("email").split(' ')
           var emailsecondhalf = emailarr[1].split('@')
           var emailfinal = "".concat(emailarr[0]).concat('@').concat(emailsecondhalf[1])
           VerifyProfile("".concat(emailarr[0]).concat('+').concat(emailarr[1]),params.get("code"))
           setEmail(emailfinal)
         }
         //
      }
    }
    if(params.get("password")==="true"){
        setEmail(params.get("email"))
        setCode(params.get("code"))
        setButtonClick(3)
    }
   
  },[])

  const VerifyProfile = (email,code)=> {
    console.log("In verify profile")
    console.log(email)
    console.log(code)
    axios.post("https://n3rve.fly.dev/auth/verify",{
      "email":email,
      "code":code,
      "verify":true,
      "newPassword":'Whatever'
    }).
      then((response)=>{
        cookies.set('token', response.data.token);

        if(response.status===200){
          // navigate("/SelectPlan", {state:{email:email}})
          console.log(response)
          setButtonClick(2)
        }
        
      }).catch(function (e){
        console.log(e.response.data)
        if(e.response!==undefined){
        
        }
    });
  }

  const changePassword = () =>{
    console.log("In verify profile")
    console.log(email)
    console.log(code)
    axios.post("https://n3rve.fly.dev/auth/verify",{
      "email":email,
      "code":code,
      "verify":false,
      "newPassword":password
    }).
      then((response)=>{
        cookies.set('token', response.data.token);

        if(response.status===200){
          // navigate("/SelectPlan", {state:{email:email}})
          console.log(response)
          HandleLogin()
        }
        
      }).catch(function (e){
        console.log(e.response.data)
        if(e.response!==undefined){
        
        }
    });
  }

  const HandleLogin = () => {

       axios({
          method: 'post',
          url: "https://n3rve.fly.dev/auth/login",
          headers: {}, 
          data: {
           email: email, 
           password: password
          }
        }).then(function (response) {
          console.log(response)
         
          if(response.status===200){
                    const current = new Date();
                    const nextYear = new Date();
                    nextYear.setFullYear(current.getFullYear() + 1)
  
                   
                    cookies.set('token', response.data.token);
                    
                    cookies.set('artistname', "");
                  
                    cookies.set('staysignedin', false);
                    
                    if(cookies.get("token")===null){
                      navigate("/mfa",{state:{email:email}})
                    }else{
                      navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:true}})
                    }
          }
        }).catch(function (e){
                console.log(e)
          });

  }

  const HandleSignUp = () => {
   
    var arr= email.split('@')
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let count = 0
    var result =''
    while (count < 5) {
      result += characters.charAt(Math.floor(Math.random() *charactersLength));
      count += 1;
    }
    arr[0]=arr[0].concat("+").concat(result)
    var resendemail = ''
    resendemail=resendemail.concat(arr[0]).concat('@').concat(arr[1])
   
    console.log("In Verify")
    console.log(resendemail)
    console.log(password)
    console.log(password2)
   
    axios.post("https://n3rve.fly.dev/auth/signup",{
      "email":resendemail,
      "password":password,
      "confirmPassword":password2,
      "domain":'http://localhost:3000'
      // "domain":'https://n3rve-b4b3b625d069.herokuapp.com'
    }).
      then((response)=>{

        if(response.status===200){
          console.log(response)
          setButtonClick(1)
        }
        
      }).catch(function (e){
        console.log(e.response.data)
        if(e.response!==undefined){
          if(e.response.data=="Email exists"){
            console.log("Email exists")
          }
        }
    });

}

useEffect(()=>{
  console.log("Refresh email")
  console.log(email)
},[email])

  

  useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft) return;

    if(timeLeft===1){
      console.log("TIME LEFT IS 1");
      setButtonClick(0)
    }

    if(timeLeft===0){
       console.log("TIME LEFT IS 0");
    }

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
  // clear interval on re-render to avoid memory leaks
  return () => clearInterval(intervalId);
}, [timeLeft]);


  return (
    <div className="PassResetContainer">

      <div className='PassResetContainerLeft' >
          <Link to="/"  style={{ textDecoration: 'none' }}>
            <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo'/>
            </Link>

           
            <div style={{display:'flex',flexDirection:'column',marginLeft:'11.25em'}}>
                  

                    {
                        buttonClick===0 &&
                        <div>
                            <div className='WelcomeBackTxt'>Verify Your Email</div>
                    <span className='PleaseEnterTxt'>Almost there! We've sent you an email to &nbsp;
                               <span style={{color:'#FFFFFF'}}>{email}</span>.<br/> Click the verification link inside to continue.<br/><br/><br/></span>
                          <span className='DontHaveAccTxt'>Didn't receive?&nbsp;&nbsp;&nbsp; <span className='DontHaveAccTxt' style={{color:'#FF6694',cursor:'pointer'}} onClick={()=>{HandleSignUp();setTimeLeft(30)}}>Resend now</span></span>
                        </div>  
                    }

                    {   
                        buttonClick===1 &&
                        <div>
                            <div className='WelcomeBackTxt'>Verify Your Email</div>
                    <span className='PleaseEnterTxt'>Almost there! We've sent you an email to &nbsp;
                               <span style={{color:'#FFFFFF'}}>{email}</span>.<br/> Click the verification link inside to continue.<br/><br/><br/></span>
                            <span className='DontHaveAccTxt'>Didn't receive?&nbsp;&nbsp;&nbsp; <span className='DontHaveAccTxt' style={{color:'rgba(255,255,255,50%)',cursor:'pointer',fontWeight:'300'}}>Wait for {timeLeft} seconds...</span></span>
                            <div className='PleaseEnterTxt' style={{color:'#60E5C5'}} onClick={()=>setButtonClick(0)}>We have sent you a new verification email to {email}.<br/> Please check your inbox</div>
                        </div>
                    }
                    {   
                        buttonClick===2 &&
                        <div>
                            <div className='WelcomeBackTxt'>Verified!</div>
                            <span className='PleaseEnterTxt'>You're all set to explore and enjoy all the features available to you.<br/> Welcome aboard!</span>
                            
                            <div className='LoginBtn' onClick={()=>navigate("/SelectPlan",{state:{email:email}})} style={{cursor:'pointer'}}>Go to account<div className="HoverOverlay" /></div>
                        </div>
                    }

                  {   
                        buttonClick===3 &&
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <div className='WelcomeBackTxt' style={{fontWeight:'500',fontSize:'3.4rem',marginTop:'2.5em'}}>Reset Password</div>
                            <span className='ResetPassowrdH1'>Please enter your new password below then click “Submit”.</span>

                            <span className='ResetPassowrdH1'>Password criteria:</span>
                            <span className='ResetPassowrdH1' style={{marginTop:'0em',fontWeight:'400',fontSize:'1rem'}}>&#8226; &nbsp;At least 8 characters long</span>
                            <span className='ResetPassowrdH1' style={{marginTop:'0em',fontWeight:'400',fontSize:'1rem'}}>&#8226; &nbsp;Contains a mix of letters, numbers, and symbols</span>
                            <span className='ResetPassowrdH1' style={{marginTop:'0em',fontWeight:'400',fontSize:'1rem'}}>&#8226; &nbsp;Does not include common passwords or sequences</span>
                            
                           

                            <div  className='SignupHeader' style={{marginTop:'3em'}}>New Password</div>

                            {
                              !passwordEmptyError && !passwordMismatchError && 
                              <input
                              value={password}
                              onChange={e => {setPassword(e.target.value); validate(e.target.value)}} 
                              placeholder='Enter Password'
                              className='SignupInput' 
                              type='password'
                              />
                            }

                            {
                              (passwordEmptyError || passwordMismatchError) &&
                              <input
                              value={password}
                              onChange={e =>{setPassword(e.target.value); validate(e.target.value)}} 
                              placeholder='Enter Password'
                              className='SignupInput' 
                              type='password'
                              style={{border:'1px #FF6363 solid'}}
                              />
                            }

                            {
                              passwordSyntaxError &&
                              <div className='ErrorTxt'>Invalid Syntax</div>
                            }

                            {
                              passwordEmptyError &&
                              <div className='ErrorTxt'>Password cannot be empty</div>
                            }

                            <div  className='SignupHeader'>Confirm New Password</div>

                            {
                            !confirmError && !passwordMismatchError &&
                            <input
                            value={password2}
                            onChange={e =>setPassword2(e.target.value)} 
                            placeholder='Enter Password'
                            className='SignupInput' 
                            type='password'
                            />
                            }

                            {
                            (confirmError || passwordMismatchError) &&
                            <input
                            value={password2}
                            onChange={e => setPassword2(e.target.value)} 
                            placeholder='Enter Password'
                            className='SignupInput' 
                            type='password'
                            style={{border:'1px #FF6363 solid'}}
                            />
                            }   


                            {
                              confirmError &&
                              <div className='ErrorTxt'>Confirm Password cannot be empty</div>
                            }

                            {
                              passwordMismatchError &&
                              <div className='ErrorTxt'>Passwords do not match</div>
                            }


                            <div className='LoginBtn' onClick={()=>handleSubmit()}>Submit<div className="HoverOverlay" /></div>

                            <span className='ContactSupperMsg'>If you did not request a password reset or need help, please  <span style={{textDecoration:'underline',fontWeight:'600'}}>contact support</span></span>
                        </div>
                    }
                   
            </div>
            

            
      </div>

      <div className='PassResetContainerRight' style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/eyufx2dvaxabuykbx9sl")`,height:dimensions.height,width:'50%'}}/>
        

  </div>
  );
}

export default VerifyEmail;